import React, { Component } from 'react';
import './notificationStripe.scss'

/*-- Imports for redux --*/
import { connect } from 'react-redux';

/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        notificationStripe: state.outsideNotificationStripe
    }
};

/*-- Map the redux actions to props --*/
const mapDispatchToProps = {};

class OutsideNotificationStripe extends Component {
    render() {
        return (
            <React.Fragment>
                {
                    this.props.notificationStripe.isActive ?
                        <div className={`notification-stripe ${this.props.notificationStripe.cssClass}`}>{this.props.notificationStripe.message}</div>
                        : null
                }
            </React.Fragment>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OutsideNotificationStripe);